/**
 * WBTagalysApi - the transport shared by tagalys-search.js and
 * tagalys-recommendations.js: a GET to Tagalys' v2 storefront API, resolving
 * to the parsed body or null (v2 only, as Tagalys asked 07.10.2026). Analytics don't go through here but
 * through Tagalys' SDK (snippets/tagalys-analytics.liquid). Config comes from
 * window.wbTagalysSearchConfig (snippets/tagalys-search-settings.liquid).
 */
(function () {
  var config = window.wbTagalysSearchConfig;
  if (!config || !config.clientCode || !config.publicApiKey) {
    console.error('[WBTagalys] Missing Tagalys client_code/public_api_key - see snippets/tagalys-search-settings.liquid.');
  }

  // v2 storefront API (GET, no key - the shop is identified by shop_id).
  // options: {signal, label}. label prefixes console errors so the caller that
  // failed stays recognisable. An aborted request resolves to null without
  // logging - the caller aborted it on purpose.
  // params: {key: value | [values]}; arrays are sent as key[]=value.
  // shop_id, country and language are added from the config.
  function get(path, params, options) {
    options = options || {};
    var label = options.label || '[WBTagalys]';
    var apiServer = (config.apiServer || 'https://api-rx.tagalys.com').replace(/\/+$/, '');
    var query = [];
    var all = Object.assign({ shop_id: config.shopId, country: config.country, language: config.language }, params || {});
    Object.keys(all).forEach(function (key) {
      var value = all[key];
      if (value === undefined || value === null || value === '') return;
      if (Array.isArray(value)) {
        value.forEach(function (item) {
          query.push(encodeURIComponent(key) + '[]=' + encodeURIComponent(item));
        });
      } else {
        query.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
      }
    });
    var url = apiServer + path + '?' + query.join('&');
    return fetch(url, { signal: options.signal }).then(function (response) {
      if (!response.ok) {
        return response.text().then(function (text) {
          console.error(label, 'HTTP error', path, response.status, response.statusText, text);
          return null;
        });
      }
      return response.json();
    }).catch(function (error) {
      if (error && error.name === 'AbortError') return null;
      console.error(label, 'fetch error', path, error);
      return null;
    });
  }

  window.WBTagalysApi = {
    get: get
  };
})();
